import { ENVIRONMENT } from '@experiences/constants';

export function getEnvironment() {
    if (window.location.origin.toLowerCase().indexOf('localhost') >= 0) {
        return ENVIRONMENT.LOCAL;
    }
    return window.env?.ENVIRONMENT;
}
